export const environment = {
  production: true,
  azure: {
    apiBaseUrl: 'https://picwebapidev-g7fthpchfmcmbda8.southafricanorth-01.azurewebsites.net/api', // Localhost URL for backend API
    clientId: '539aaef5-1380-4033-998c-afd85018aa8c', // Replace with your Azure AD application client ID
    tenantId: '06fdb25e-a78c-4818-a304-562007fd761b', // Replace with your Azure AD tenant ID
  },
  auth: {
    authority: 'https://login.microsoftonline.com/06fdb25e-a78c-4818-a304-562007fd761b', // Replace with your Azure AD authority
    redirectUri: 'https://fundingqa.pic.gov.za', // Localhost URL for Angular app
    scopes: ['api://539aaef5-1380-4033-998c-afd85018aa8c/access_as_user'], // Replace with your API scopes
  },
  development: {
    enableEmailSending: true, // Enable email sending in development
    enableRecaptcha: true, // Enable reCAPTCHA in development
    enableApiLogging: true, // Enable detailed API logging for debugging
    mockApiResponses: false, // Backend API is ready - using real service
  },
};
